import { FC, ReactNode, useState } from "react";
import { Modal, ModalProps } from "antd";
import SheetHeader from "../SheetHeader/SheetHeader";
import type { CarrierHelpers } from "../Carrier/Carrier";

export type AppModalProps = {
  renderTrigger: (helpers: CarrierHelpers) => ReactNode;
  renderSheet: (helpers: CarrierHelpers) => ReactNode;
  label?: ReactNode;
  showTitle?: boolean;
} & Partial<Omit<ModalProps, "open" | "title" | "footer">>;

const MODAL_WIDTH = 820;

const AppModal: FC<AppModalProps> = ({ renderTrigger, renderSheet, label, showTitle = true, width = MODAL_WIDTH, classNames, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <>
      {renderTrigger({ isOpen, open, close })}
      <Modal
        open={isOpen}
        onCancel={close}
        footer={null}
        closeIcon={null}
        centered
        width={width}
        title={showTitle ? <SheetHeader label={label} onClose={close} /> : null}
        classNames={{
          container: "p-0! rounded-xl! overflow-hidden",
          header: "p-2! m-0!",
          body: "p-0! max-h-[75vh] overflow-y-auto custom-scrollbar",
          ...classNames,
        }}
        {...props}
      >
        {renderSheet({ isOpen, open, close })}
      </Modal>
    </>
  );
};

export default AppModal;
